import Chat from "@/public/assets/icons/LeftSidebar/chat.svg";
import Generator from "@/public/assets/icons/LeftSidebar/Group.svg";
import Editor from "@/public/assets/icons/LeftSidebar/Image_edit.svg";
import History from "@/public/assets/icons/LeftSidebar/History.svg";
import Explore from "@/public/assets/icons/LeftSidebar/Explore.svg";
import VideoGenerator from "@/public/assets/icons/LeftSidebar/ideo.svg";
import Settings from "@/public/assets/icons/LeftSidebar/elements.svg";
import Arrow from "@/public/assets/icons/RightSidebar/Arrow.svg";
import Model from "@/public/assets/icons/RightSidebar/Model.svg";
import More from "@/public/assets/icons/RightSidebar/More.svg";
import Info from "@/public/assets/icons/RightSidebar/Info.svg";
import Fileupload from "@/public/assets/icons/Input/FileUpload.svg";
import EnhancePrompt from "@/public/assets/icons/Input/EnhancePrompt.svg";
import Cross from "@/public/assets/icons/RightSidebar/Cross.svg";
import ArrowShort from "@/public/assets/icons/RightSidebar/Arrowshort.svg";
import Selected from "@/public/assets/icons/RightSidebar/Selected.svg";
import Credits from "@/public/assets/icons/RightSidebar/Credits.svg";
import Fast from "@/public/assets/icons/RightSidebar/Fast.svg";
import Favourite from "@/public/assets/icons/RightSidebar/Favourite.svg";
import All from "@/public/assets/icons/RightSidebar/All.svg";
import Clock from "@/public/assets/icons/RightSidebar/Clock.svg";
import Runs from "@/public/assets/icons/RightSidebar/Runs.svg";
import AspectRatio from "@/public/assets/icons/RightSidebar/AspectRatio.svg";
import AspectRatioPlain from "@/public/assets/icons/RightSidebar/AspectRatioPlain.svg";
import HeartIcon from "@/public/assets/icons/RightSidebar/HeartIcon.svg";
import Download from "@/public/assets/icons/ImageInterface/Download.svg";
import Share from "@/public/assets/icons/ImageInterface/Share.svg";
import Regenerate from "@/public/assets/icons/ImageInterface/Regenerate.svg";
import Edit from "@/public/assets/icons/ImageInterface/Edit.svg";
import Search from "@/public/assets/icons/Dashboard/Search.svg";
import Close from "@/public/assets/icons/RightSidebar/Close.svg";
import Instagram from "@/public/assets/icons/Share/Instagram.svg";
import Facebook from "@/public/assets/icons/Share/Facebook.svg";
import Twitter from "@/public/assets/icons/Share/Twitter.svg";
import Linkedin from "@/public/assets/icons/Share/Linkedin.svg";
import ArrowRight from "@/public/assets/icons/LeftSidebar/Arrow.svg";
import Bg from "@/public/assets/icons/LeftSidebar/Bg.svg";
import Menu from "@/public/assets/icons/ImageInterface/Menu.svg";
import Tick from "@/public/assets/icons/pricing/Tick.svg";
import OpenMenu from "@/public/assets/icons/Input/OpenMenu.svg";
import Down from "@/public/assets/icons/Down.svg";
import Infobutton from "@/public/assets/icons/ImageInterface/Info.svg";
import Generative from "@/public/assets/icons/Dashboard/Generative.svg";
import Undo from "@/public/assets/icons/Image-Editor/Undo.svg";
import Redo from "@/public/assets/icons/Image-Editor/Redo.svg";
import Reset from "@/public/assets/icons/Image-Editor/Reset.svg";
import BGremover from "@/public/assets/icons/Image-Editor/BGremover.svg";
import Upscale from "@/public/assets/icons/Image-Editor/Upscale.svg";
import Select from "@/public/assets/icons/Image-Editor/Select.svg";
import Image from "@/public/assets/icons/ImageInterface/Image.svg";
import EditIcon from "@/public/assets/icons/Input/Edit.svg";
import GradientArrow from "@/public/assets/icons/LandingPage/Arrow 1.svg";

export const Icons = {
  select: Select,
  upscale: Upscale,
  bgremover: BGremover,
  reset: Reset,
  redo: Redo,
  undo: Undo,
  chat: Chat,
  image: Image,
  generator: Generator,
  videoGenerator: VideoGenerator,
  editIcon: EditIcon,
  editor: Editor,
  history: History,
  explore: Explore,
  settings: Settings,
  arrow: Arrow,
  model: Model,
  more: More,
  info: Info,
  fileupload: Fileupload,
  enhanceprompt: EnhancePrompt,
  cross: Cross,
  arrowshort: ArrowShort,
  selected: Selected,
  credits: Credits,
  fast: Fast,
  favourite: Favourite,
  all: All,
  clock: Clock,
  runs: Runs,
  aspectRatio: AspectRatio,
  aspectRatioPlain: AspectRatioPlain,
  heartIcon: HeartIcon,
  download: Download,
  share: Share,
  regenerate: Regenerate,
  edit: Edit,
  search: Search,
  close: Close,
  instagram: Instagram,
  facebook: Facebook,
  twitter: Twitter,
  linkedin: Linkedin,
  arrowright: ArrowRight,
  bg: Bg,
  openmenu: OpenMenu,
  menu: Menu,
  tick: Tick,
  down: Down,
  infobutton: Infobutton,
  generative: Generative,
  gradientArrow: GradientArrow,
  loading: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M21 12a9 9 0 1 1-6.219-8.56" />
    </svg>
  ),
};
// export type IconType = keyof typeof Icons;
